import { AttendanceFeatureConfigSchema, type AttendanceFeatureConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Global `attendance`.
 *
 * Not absentIsEmpty: the fleet-default GLOBAL_FEATURE_CONFIGS row carries
 * `attendance` (read-only production query, `SystemConfiguration`, 2026-10-02),
 * so a not-found answer is a real fault.
 *
 * Fallback, for fields absent from the merged block (both fail closed):
 * - `teacherAttendanceState: 'off'`
 *   (`apps/backend/src/services/config/global-features.ts:639`).
 * - `allowParentReportAbsence: false`
 *   (`apps/mobile/src/hooks/attendance/use-attendance-config.ts:154`).
 */
export const attendance: ScreenFeatureEntry<'global', 'attendance', AttendanceFeatureConfig> = {
  resource: 'global',
  wireName: 'attendance',
  schema: AttendanceFeatureConfigSchema,
  writeMode: 'sparse',
  fallback: {
    teacherAttendanceState: 'off',
    allowParentReportAbsence: false
  }
}
